import { useEffect, useState, useRef } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, Upload, ImagePlus, Check } from "lucide-react";

export function MediaPicker({ selected, onSelect }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const load = () => {
    setLoading(true);
    api.get("/media").then((r) => setItems(r.data)).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    const form = new FormData();
    form.append("file", file);
    try {
      const res = await api.post("/media", form, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Imagen subida");
      setItems((prev) => [res.data, ...prev]);
      onSelect(res.data.id);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo subir la imagen");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div data-testid="media-picker">
      <input ref={fileRef} type="file" accept="image/*" className="hidden" data-testid="media-upload-input"
        onChange={(e) => upload(e.target.files?.[0])} />
      <Button type="button" variant="outline" size="sm" onClick={() => fileRef.current?.click()} disabled={uploading} data-testid="media-upload-button">
        {uploading ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <Upload className="h-4 w-4 mr-1" />} Subir imagen
      </Button>

      {loading ? (
        <div className="py-6 flex justify-center"><Loader2 className="h-5 w-5 animate-spin text-[#0055FF]" /></div>
      ) : items.length === 0 ? (
        <div className="py-6 text-center text-xs text-[#71717A] flex flex-col items-center gap-2">
          <ImagePlus className="h-6 w-6 text-[#A1A1AA]" /> Todavía no subiste imágenes.
        </div>
      ) : (
        <div className="grid grid-cols-4 gap-2 mt-3 max-h-48 overflow-y-auto">
          {items.map((m) => (
            <button
              type="button" key={m.id} onClick={() => onSelect(m.id)} data-testid={`media-thumb-${m.id}`}
              className={`relative aspect-square rounded-sm overflow-hidden border-2 ${selected === m.id ? "border-[#0055FF]" : "border-transparent"}`}
            >
              <img src={m.public_url} alt={m.alt_text || ""} className="w-full h-full object-cover" />
              {selected === m.id && (
                <div className="absolute inset-0 bg-[#0055FF]/40 grid place-items-center">
                  <Check className="h-5 w-5 text-white" />
                </div>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
